module.exports = __webpack_public_path__ + "static/resources_03-560x320-e12f151f739192cb0de8e24c4ef2bd1d.jpg";